const VisPageConcent = () => import('@/views/vis-page-concent');

export default [
  {
    path: "/concent",
    name: "concent",
    component: VisPageConcent,
    props: route => ({ state: route.query.state })
  }
]
